import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  url=ConfigService.toApiUrl("bulletins/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-by-state")}/${state}`,ConfigService.addAction('list'));
  }

   
  generateAssessmentBulletin(classroomId:any,periodId:any,pacId:any,sacId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-assessment")}/${classroomId}/${periodId}/${pacId}/${sacId}`,ConfigService.addAction('list'));
  }
   
  getTemplate(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-template")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }

  getTemplateAssessment(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-template-assessment")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }


  getForStudent(studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-resources-student")}`,ConfigService.addAction('list'));

    } else {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-resources-student")}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('list'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
  confirm(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-confirmation")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
  publish(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("bulletins-publish")}`,resource,ConfigService.addAction('list'));
  }

  getByClassroomPeriods(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("bulletins-by-classroom-periods")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }


  
}
